import React from 'react';
import PropTypes from 'prop-types';
import BaseLayout from 'bento-ordering/base/layouts/Layout';
import { SIX } from 'bento-ordering/base/constants/grid';

const layoutPadding = {
  pt: SIX
};

class LocationDetailPageLayout extends React.Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]).isRequired
  };

  render() {
    return (
      <BaseLayout hideMobileStickyCtaFooter layoutPadding={layoutPadding}>
        {this.props.children}
      </BaseLayout>
    );
  }
}

export default LocationDetailPageLayout;
